import { forwardRef, useState } from "react";
import { Button, Col, Descriptions, Form, Radio, Row, InputNumber } from "antd";

import CareItemForm from "../CareItemForm";
import { yesNoOptions } from "../../../../../constants/defaultKeys";
import { tracheostomyOptions } from "../../../Options/careItemsOptions";
import { PlusOutlined } from "@ant-design/icons";
import useQuery from "../../../../../hooks/useQuery";

const formItems = (
  <>
    <Form.Item
      label="Tracheostomy"
      name="tracheostomy"
      rules={[{ required: true, message: "Please select an option" }]}
    >
      <Radio.Group options={tracheostomyOptions} />
    </Form.Item>
    <Form.Item label="Size" name="tracheostomy_size">
      <InputNumber style={{ width: "20%" }} />
    </Form.Item>
    <Form.Item label="Trial of Decannulation" name="decannulation_trial">
      <Radio.Group options={yesNoOptions} />
    </Form.Item>
  </>
);

const tracheostomyItems = (item) => [
  {
    key: "tracheostomy",
    label: "Tracheostomy",
    children:
      tracheostomyOptions?.find((option) => option.value === item?.tracheostomy)
        ?.label || "-",
  },
  {
    key: "decannulation_trial",
    label: "Trial of Decannulation",
    children: item?.decannulation_trial === "yes" ? "Yes" : "No",
  },
  {
    key: "tracheostomy_size",
    label: "Size",
    children: item?.tracheostomy_size || "-",
  },
];

function Tracheostomy(props, ref) {
  const {
    getData,
    iaAction,
    formData,
    formState: formStateProp,
    setFormState: setFormStateProp,
    isIaCareItem,
    updateIACareItemRecord,
  } = props;
  const [localFormState, setLocalFormState] = useState({
    editingIndex: null,
    adding: false,
  });
  const formState = formStateProp ?? localFormState;
  const setFormState = setFormStateProp ?? setLocalFormState;
  const isActive = useQuery()?.status === "current";
  return (
    <Row gutter={[12, 12]}>
      {(!formData || formData?.isallstopstate) && (
        <>
          {formData !== undefined && !formState?.adding ? (
            <Col
              span={24}
              className="add-another-row"
            >
              {isActive && (
                <Button
                  type="default"
                  className="add-another-btn"
                  onClick={() =>
                    setFormState((prev) => ({
                      ...prev,
                      adding: "respiratory_care_tracheostomy_care",
                    }))
                  }
                >
                  <PlusOutlined /> Add Another
                </Button>
              )}
            </Col>
          ) : (
            (formState?.adding === "respiratory_care_tracheostomy_care" ||
              !formData) && (
              <CareItemForm
                getData={getData}
                formItems={formItems}
                formState={formState}
                setFormState={setFormState}
                formType="respiratory_care_tracheostomy_care"
              />
            )
          )}
        </>
      )}
      {formData?.data?.map((item, index) => (
        <CareItemForm
          ref={ref}
          key={index}
          formData={item}
          getData={getData}
          iaAction={iaAction}
          formState={formState}
          isIaCareItem={isIaCareItem}
          setFormState={setFormState}
          formType="respiratory_care_tracheostomy_care"
          updateIACareItemRecord={updateIACareItemRecord}
          formItems={
            isIaCareItem ||
            item === undefined ||
            formState?.editingIndex === item?.id ? (
              formItems
            ) : (
              <Descriptions
                className="descriptions-custom-column-width"
                column={1}
                bordered
                items={tracheostomyItems(item?.data)}
              />
            )
          }
        />
      ))}
    </Row>
  );
}

export default forwardRef(Tracheostomy);
